import React from "react";

type MembershipLogo = {
    src: string;
    alt: string;
    href: string;
};

const membershipLogos: MembershipLogo[] = [
    { src: "/images/proudpartners/ada-logo.webp", alt: "ADA", href: "https://www.ada.org/" },
    { src: "/images/proudpartners/ADSO-logo.webp", alt: "ADSO", href: "https://www.theadso.org/" },
    { src: "/images/proudpartners/agd-logo.webp", alt: "AGD", href: "https://www.agd.org/membership" },
    { src: "/images/proudpartners/women_in_dso.webp", alt: "Women in DSO", href: "https://womenindso.org/" },
    { src: "/images/proudpartners/AADOM.webp", alt: "AADOM", href: "https://www.dentalmanagers.com/" },
    { src: "/images/proudpartners/AADGP.webp", alt: "AADGP", href: "https://www.aadgp.org/" },
];

const MembershipSection: React.FC = () => (
    <div className="footer-band">
        <div className="container">
            <p className="footer-band__title">We Are Proud Members Of</p>
            <div className="footer-band__logos">
                {membershipLogos.map(({ src, alt, href }, idx) => (
                    <a key={idx} href={href} target="_blank" rel="noopener noreferrer" className="footer-logo">
                        <img src={src} alt={alt} />
                    </a>
                ))}
            </div>
        </div>
    </div>
);

export default MembershipSection;
